import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-[#0C0C10]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#F4F1EA] p-1">
            <img src="/logo.png" alt="NAKSRA logo" className="h-full w-full object-contain" />
          </span>
          <span className="font-heading text-2xl font-semibold tracking-[0.25em] text-[#F8F9FA]">NAKSRA</span>
        </Link>
        <nav className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <Link to="/privacy" data-testid="nav-gdpr-badge" title="GDPR — Personal Data Privacy Policy">
              <img src="/gdpr.png" alt="GDPR — General Data Protection Regulation" className="h-8 w-8 rounded-full transition-transform duration-300 hover:scale-110" />
            </Link>
            <Link to="/privacy" data-testid="nav-iso-badge" title="ISO 27701 — Personal Data Privacy Policy">
              <img src="/iso.png" alt="ISO 27701 certified" className="h-8 w-8 transition-transform duration-300 hover:scale-110" />
            </Link>
          </div>
          <Link to="/services" data-testid="nav-services-link" className="text-sm font-medium text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">
            Reports
          </Link>
          <Link to="/blog" data-testid="nav-blog-link" className="text-sm font-medium text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">
            Sangha
          </Link>
          {user === undefined ? null : user ? (
            <>
              <Link to="/account" data-testid="nav-account-link" className="text-sm font-medium text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">
                My Reports
              </Link>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin-link" className="text-sm font-medium text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">
                  Admin
                </Link>
              )}
              <button
                onClick={handleLogout}
                data-testid="nav-logout-btn"
                className="rounded-full border border-white/20 px-5 py-1.5 text-sm font-medium text-white transition-colors duration-300 hover:bg-white/5"
              >
                Sign out
              </button>
            </>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login-link"
              className="rounded-full bg-[#D4AF37] px-5 py-1.5 text-sm font-semibold text-black transition-colors duration-300 hover:bg-[#FBE18D]"
            >
              Sign in
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
